import React from 'react';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { buildTabChangeMap } from '../../../../../utils/dealerApprovalEnums';
import TabChangeBadge from '../../../customer/customerAddressBrandPage/components/tabs/TabChangeBadge';

const ROW_STATE_KEY = {
    0: 'dealerRegistration.rowState.live',
    1: 'dealerRegistration.rowState.pendingInsert',
    2: 'dealerRegistration.rowState.pendingUpdate'
};

const rowStateSeverity = (code) => {
    if (code === 1) return 'success';
    if (code === 2) return 'warning';
    return 'success';
};

const summarizeTabChanges = (tabChanges) => {
    const map = buildTabChangeMap(tabChanges || []);
    const totalCount = Object.values(map).reduce((sum, item) => sum + (item.totalCount || 0), 0);
    return totalCount > 0 ? { totalCount } : null;
};

/**
 * Onay / kayıt ekranında adres+marka bloğu bazlı değişiklik özeti.
 * blocks[] (DealerApproval/GetById) veya addresses[] (DealerRegistration/GetById) kabul eder.
 */
const ApprovalBlocks = ({ blocks = [] }) => {
    const { th } = useLanguage();
    if (!Array.isArray(blocks) || blocks.length === 0) return null;

    return (
        <div className="mb-3">
            <h5 className="mt-0 mb-2">{th('dealerRegistration.form.addressInfo')}</h5>
            <div className="flex flex-column gap-2">
                {blocks.map((block, index) => {
                    const stateCode = block.rowState ?? 0;
                    const address = block.addressName || block.address || block.sapAddrId || '';
                    const brand = block.brandName || block.brandShort || '';
                    const key = block.dealerAddressBrandId ?? `${block.sapAddrId}-${block.brandId}-${index}`;
                    return (
                        <div key={key} className="flex align-items-center justify-content-between gap-2 p-2 border-round surface-100">
                            <div className="flex align-items-center gap-2 flex-wrap">
                                <span className="font-medium">
                                    {address}
                                    {brand ? ` — ${brand}` : ''}
                                </span>
                                {stateCode > 0 && <Tag value={th(ROW_STATE_KEY[stateCode] || ROW_STATE_KEY[0])} severity={rowStateSeverity(stateCode)} />}
                                <TabChangeBadge tabChange={summarizeTabChanges(block.tabChanges)} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ApprovalBlocks;
